import WebsiteRatingModel from '@/components/common/stat/website-rating-model'
import {WEBSITE_RATING} from '@/constant/common/stat/WEBSITE_RATING'

let mixin = {
  data() {
    return {
      WEBSITE_RATING
    }
  },
  components: {
    WebsiteRatingModel
  }
}

export default mixin;
